import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { ReactComponent as CircleTickIcon } from "assets/icons/circle_tick.svg";
import { ReactComponent as CircleWarinigIcon } from "assets/icons/circle_warning.svg";
import { ReactComponent as CircleClockIcon } from "assets/icons/circle_clock.svg";
import { ReactComponent as CircleDraft } from "assets/icons/circle_draft.svg";
import { ORDER_STATUS } from "utils/Constants";
import { CustomTabsProps } from "./WeekDaysTab.props";
import "./style.scss";

export const weekDays = [
    {
        id: 1,
        title: "شنبه",
        status: 0,
    },
    {
        id: 2,
        title: "یکشنبه",
        status: 0,
    },
    {
        id: 3,
        title: "دوشنبه",
        status: 0,
    },
    {
        id: 4,
        title: "سه‌شنبه",
        status: 0,
    },
    {
        id: 5,
        title: "چهارشنبه",
        status: 0,
    },
    {
        id: 6,
        title: "پنج‌شنبه",
        status: 0,
    },
    {
        id: 7,
        title: "جمعه",
        status: 0,
    },
];

const WeekDaysTab: React.FC<CustomTabsProps> = ({
    onChange,
    weekDaysStatus,
    activeTab,
    disabledDays,
}) => {
    weekDaysStatus &&
        weekDaysStatus.forEach((item, index) => {
            if (index <= 7) {
                weekDays[index].status = item.status;
            }
        });

    const renderIconByStatus = {
        [ORDER_STATUS.pending]: (
            <CircleClockIcon
                className="ml-2 clock-icon"
                style={{ fill: "red" }}
                width={16}
                height={16}
            />
        ),
        [ORDER_STATUS.changed]: (
            <CircleWarinigIcon className="ml-2" width={16} height={16} />
        ),
        [ORDER_STATUS.vendor_accepted]: (
            <CircleTickIcon className="ml-2" width={16} height={16} />
        ),
        [ORDER_STATUS.kitchen_accepted]: (
            <CircleTickIcon className="ml-2" width={16} height={16} />
        ),
        [ORDER_STATUS.direct_confirm]: (
            <CircleTickIcon className="ml-2" width={16} height={16} />
        ),
        [ORDER_STATUS.is_draft]: (
            <CircleDraft className="ml-2" width={16} height={16} />
        ),
    };

    return (
        <div
            className={`WeeklyTabsContainer ${
                weekDaysStatus ? "hasStatus" : ""
            }`}
        >
            <Tabs
                onSelect={(val) => {
                    onChange(val as string);
                }}
                defaultActiveKey={"1"}
                activeKey={activeTab || "1"}
            >
                {weekDays.map((item) => (
                    <Tab
                        disabled={disabledDays}
                        key={item.id}
                        tabClassName={`WeeklyTabsContainer ${
                            weekDaysStatus ? "hasStatus" : "withoutStatus"
                        }`}
                        eventKey={item.id}
                        title={
                            weekDaysStatus && item.status ? (
                                <span>
                                    {weekDaysStatus &&
                                        item.status &&
                                        //@ts-ignore
                                        renderIconByStatus[item.status]}
                                    {item.title}
                                </span>
                            ) : (
                                item.title
                            )
                        }
                    />
                ))}
            </Tabs>
        </div>
    );
};

export default WeekDaysTab;
